var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#9D8A20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.21 14.9633H5.87326C5.56253 14.9633 5.31055 14.7113 5.31055 14.4006C5.31055 14.0899 5.56253 13.8379 5.87326 13.8379H14.21C14.5207 13.8379 14.7727 14.0899 14.7727 14.4006C14.7727 14.7113 14.5207 14.9633 14.21 14.9633Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25767 12.5217C6.77858 12.5217 6.1153 12.5217 5.19553 12.5217C4.88479 12.5217 4.63281 12.2698 4.63281 11.959C4.63281 11.6483 4.88479 11.3963 5.19553 11.3963C5.66558 11.3963 6.31756 11.3963 6.9153 11.3963C6.37519 10.7183 6.07688 9.8788 6.07462 8.98953C6.07462 8.60196 6.12999 8.20987 6.24298 7.82569C6.61586 6.5545 7.64524 5.55563 8.92886 5.22004C10.1379 4.90366 11.3854 5.14885 12.3503 5.89462C13.3142 6.63925 13.8678 7.76354 13.8678 8.98049C13.8678 9.87428 13.5707 10.7161 13.0328 11.3952H14.7684C15.0791 11.3952 15.3311 11.6472 15.3311 11.9579C15.3311 12.2686 15.0791 12.5206 14.7684 12.5206H11.4758C11.2159 12.5206 10.9899 12.3421 10.9289 12.089C10.869 11.8359 10.9899 11.5748 11.2215 11.4562C11.3673 11.3827 11.5074 11.2946 11.6385 11.1963C12.3413 10.6664 12.7435 9.85959 12.7435 8.98049C12.7435 8.1014 12.3503 7.31383 11.6633 6.78388C10.9763 6.25281 10.0837 6.07993 9.2136 6.30705C8.30965 6.54433 7.58423 7.24716 7.32208 8.14094C7.23959 8.42117 7.19778 8.70591 7.19891 8.98614C7.20117 9.85281 7.60004 10.6539 8.29496 11.1839C8.38423 11.2528 8.61586 11.3918 8.75146 11.4686C8.96615 11.5907 9.07575 11.8381 9.02264 12.0788C8.96954 12.3195 8.76615 12.498 8.51982 12.5183C8.50061 12.5195 8.49496 12.5206 7.25654 12.5206L7.25767 12.5217Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibra);
export default __webpack_public_path__ + "static/media/libra.9c38287e917ac36f5d16d88c8d1ca42e.svg";
export { ForwardRef as ReactComponent };